import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledApp = styled(Box)(({ theme }) => ({
  minHeight: '100dvh',
  backgroundColor: theme.palette.background.default,
  paddingTop: '64px'
}));

export default StyledApp;
